import { useCallback, useRef, type Ref } from 'react';
import { ScrollView, type ScrollViewProps } from 'react-native';

import { useHorizontalMouseScroll } from './use-horizontal-mouse-scroll';

export type HorizontalScrollViewProps = ScrollViewProps & {
  ref?: Ref<ScrollView>;
};

function setRefValue<T>(ref: Ref<T> | undefined, value: T | null): void {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/**
 * Horizontal ScrollView with desktop mouse-wheel and click-drag support on web.
 * It remains a regular React Native ScrollView on iOS and Android.
 */
export function HorizontalScrollView({ ref, ...props }: HorizontalScrollViewProps) {
  const scrollRef = useRef<ScrollView>(null);
  useHorizontalMouseScroll(scrollRef);

  const handleRef = useCallback(
    (value: ScrollView | null) => {
      scrollRef.current = value;
      setRefValue(ref, value);
    },
    [ref],
  );

  return <ScrollView {...props} ref={handleRef} horizontal />;
}
